import $ from "@modules/jquery";

// Foundation-breakpointnamen uit de content (bijv. data-responsive-accordion-tabs="accordion medium-accordion
// large-accordion") verwijzen naar de namen van SOIL's Tailwind-breakpoints.
const mediaQueryAliases = { small: "base", medium: "sm", large: "lg", xlarge: "xl", xxlarge: "2xl" };

if (window.Foundation && window.Foundation.MediaQuery) {
  const mediaQuery = window.Foundation.MediaQuery;
  const getQuery = mediaQuery.get.bind(mediaQuery);

  mediaQuery.get = (size) => getQuery(mediaQueryAliases[size] || size);
}

$(function () {
  document.addEventListener("facetwp-loaded", function () {
    $(document).foundation();
  });

  $('.ginput_product_price_wrapper').append('<span class="ginput_product_price_label">excl. BTW</span>');
  $('.ginput_subtotal').after(' excl. BTW');

  if($('.single-post .category-evenement').find('.ms_archive future-events .wrapper').length === 0) {
      $('.single-post .category-evenement h2.title').remove();
      $('.single-post .category-evenement .future-events').remove();
  }
});
$(document).ready(function() {

  if($('.single-post .category-evenement').find('.ms_archive future-events .wrapper').length === 0) {
    $('.single-post .category-evenement h2.title').remove();
    $('.single-post .category-evenement .future-events').remove();
  }
});
$(window).on("load", function () {

  if($('.single-post .category-evenement').find('.ms_archive future-events .wrapper').length === 0) {
    $('.single-post .category-evenement h2.title').remove();
    $('.single-post .category-evenement .future-events').remove();
  }
});
